import React, { useState } from "react";
import { FaEdit } from "react-icons/fa";
import PhoneInput from "react-phone-number-input";
import { BsCheckAll } from "react-icons/bs";
import { RxCross1 } from "react-icons/rx";
import toast from "react-hot-toast";
import axios from "axios";
import { Toaster } from "react-hot-toast";
const token = localStorage.getItem("token");

let userData = JSON.parse(localStorage.getItem("userData"));
let userDataPhone;

const UpdatePhoneNo = () => {
  const [closePhoneNoPopup, setClosePhoneNoPopup] = useState(false);
  const [phone, setPhone] = useState();
  const [OTP, setOTP] = useState("");
  const [OTPSent, setOTPSent] = useState(false);
  const [OTPVerified, setOTPVerified] = useState(false);

  const [oldPhoneNo, setOldPhoneNo] = useState(userData?.phone);
  const closeBox = () => {
    setClosePhoneNoPopup(!closePhoneNoPopup);
    userData.phone = phone;
    localStorage.setItem("userData", JSON.stringify(userData));

    setOldPhoneNo(phone);
    console.log(userData);
  };

  const generateOTP = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/phone-otp-request`,
        { number: phone }
      );
      if (res.data.success) {
        console.log("Successfuly ", res.data);

        toast("Success Use this OTP : " + res?.data?.otp, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setOTPSent(true);

        // alert("Success Use this OTP : "+res?.data?.otp)
      } else {
        console.log("error ", res.data.msg);
        toast(res.data.msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setOTPSent(false);

        // alert(res.data.msg)
      }
    } catch (error) {
      toast("Error logging in:", error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      // console.error('Error logging in:', error);
    }
  };

  const verifyOTP = async (otp) => {
    console.log(otp);
    const res = await axios.post(
      `${process.env.REACT_APP_SERVER_URL}/verify-phone-request`,
      { number: phone, otpCode: otp }
    );
    console.log(res);
    if (res.data.success) {
      console.log("Successfuly ", res.data);
      setOTPVerified(true);
    } else {
      setOTPVerified(false);
      toast.error("Please try again after some time.");
    }
  };

  const updatePhone = () => {
    try {
      axios
        .put(
          `${process.env.REACT_APP_SERVER_URL}/user-phone`,
          {
            oldphone: userData.phone,
            phone: phone,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then(() => {
          localStorage.setItem("userDataPhone", phone);
          userDataPhone = localStorage.getItem("userDataPhone");
          closeBox();
          console.log("aaaaaaa", userDataPhone);
        });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className=" md:my-auto">
      <Toaster position="top-center" reverseOrder={false} />

      <div className="">
        <span className="font-medium text-xl">PhoneNo</span>
        <div className="flex items-center px-2 gap-4 font-bold text-lg mb-5 text-slate-400">
          {oldPhoneNo}
          <span
            onClick={() => setClosePhoneNoPopup(true)}
            className="text-xl hover:animate-pulse"
          >
            <FaEdit />
          </span>
        </div>
      </div>
      {closePhoneNoPopup && (
        <div
          className={"px-2 relative z-50 "}
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div
            className={`fixed inset-0 bg-black bg-opacity-20 backdrop-blur transition-opacity`}
          ></div>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-2 text-center sm:items-center ">
              <div
                className={`relative bg-gradient-to-bl from-[#212445] via-[#212445] to-[#462E52] rounded-lg shadow dark:bg-gray-700 py-2`}
              >
                <div
                  className={`bg-gradient-to-bl from-[#212445] via-[#212445] to-[#462E52] p-2`}
                >
                  <div className="sm:flex sm:items-start">
                    <div className={`p-2 `}>
                      <h3 className="mb-2 text-xl font-medium text-white dark:text-white">
                        Update PhoneNo
                      </h3>
                      <div className="relative">
                        <label className="block mb-2 text-sm text-left font-medium text-white dark:text-white">
                          Enter New Phone No
                        </label>
                        <PhoneInput
                          international
                          countryCallingCodeEditable={false}
                          defaultCountry="US"
                          onChange={setPhone}
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                        />
                        <div
                          onClick={generateOTP}
                          className={`cursor-pointer absolute bottom-5 right-4 ${
                            !OTPSent ? " bg-blue-800 " : "bg-[#00000030] "
                          } py-1  px-3 text-xs text-white rounded-lg`}
                        >
                          {" "}
                          {OTPSent ? "Sent" : "Get"}
                        </div>
                      </div>
                      <div className="relative">
                        <input
                          type="text"
                          value={OTP}
                          onChange={(e) => {
                            if (e.target.value.length <= 6) {
                              setOTP(e.target.value);
                              if (e.target.value.length == 6)
                                verifyOTP(e.target.value);
                            }
                          }}
                          placeholder="OTP"
                          className="bg-gray-50 border my-2 border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                          required
                        />
                        <div
                          className={`cursor-pointer absolute bottom-1 right-2 ${
                            OTPVerified ? "text-green-500" : "text-red-500"
                          } py-1  px-3  text-white rounded-lg `}
                        >
                          {" "}
                          {OTPVerified ? (
                            <BsCheckAll size={25} />
                          ) : (
                            <RxCross1 size={25} />
                          )}
                        </div>
                      </div>

                      <button
                        className={`w-full text-white  focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center ${
                          phone && OTPVerified ? "bg-blue-800" : "bg-blue-300"
                        } dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800`}
                        onClick={() => updatePhone()}
                        disabled={!phone || !OTPVerified}
                      >
                        Update PhoneNo
                      </button>
                    </div>
                  </div>
                </div>
                <button
                  onClick={closeBox}
                  type="button"
                  className="mx-4 mb-2 w-[90%] text-center rounded-lg bg-white px-5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 "
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdatePhoneNo;
